import { useEffect, useState } from 'react';

import { usePathname } from './use-pathname';
import { useSearchParams } from './use-search-params';
import { hasParams, removeParams, isExternalLink, removeLastSlash } from '../utils';



export function useActiveLink(itemPath, deep = true) {
  const pathname = removeLastSlash(usePathname());
  const searchParams = useSearchParams();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const pathHasParams = hasParams(itemPath);

  /* Start check */
  const notValid = itemPath.startsWith('#') || isExternalLink(itemPath);

  if (notValid || !mounted) {
    return false;
  }
  /* End check */

  /**
   * [1] Apply for Item has children or has params.
   */
  const isDeep = deep || pathHasParams;

  // console.info(isDeep ? '[deep]   :' : '[normal] :', itemPath, '-?-', pathname);

  if (isDeep) {
    const originItemPath = removeParams(itemPath);

    /**
     * [1] Deep: has params - check both path and query params match
     * @itemPath 			 = '/dashboard/test?id=e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1'
     * @match pathname = '/dashboard/test'
     */
    if (pathHasParams) {
      // Extract query params from itemPath
      const [, queryString] = itemPath.split('?');
      const itemParams = new URLSearchParams(queryString);

      // Check if path matches
      const pathMatches = originItemPath === pathname;

      if (!pathMatches) {
        return false;
      }

      // Check if all query params from itemPath exist in current URL
      let allParamsMatch = true;
      itemParams.forEach((value, key) => {
        if (searchParams.get(key) !== value) {
          allParamsMatch = false;
        }
      });

      return allParamsMatch;
    }

    /**
     * [1] Deep: default (no params in itemPath)
     * @itemPath 			 = '/dashboard/users'
     * @match pathname = '/dashboard/users'
     * @match pathname = '/dashboard/users/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b15/edit'
     * 
     * Important: If itemPath has no params but current URL has params,
     * only match if it's a sub-route (e.g., /dashboard/users/edit)
     */
    // Check if current URL has query params
    const currentHasParams = searchParams.toString().length > 0;

    // If itemPath is exact match with pathname and current URL has no query params
    if (originItemPath === pathname && !currentHasParams) {
      return true;
    }

    // If itemPath is a prefix and current path extends it (sub-routes)
    // But NOT if they're the same path and current URL has query params
    const defaultActive = pathname.includes(originItemPath) && pathname !== originItemPath;

    return defaultActive;
  }

  /**
   * [1] Normal: active
   * @itemPath 			 = '/dashboard/calendar'
   * @match pathname = '/dashboard/calendar'
   */
  return pathname === itemPath;
}
